import { styled } from "styled-components";

export const ImageButton = styled.img`
  height: 70%;
`;
